<template>
    <div>
        <div v-for="(item, i) in itemArray[itemField]" :key="i">
            <div class="border p-2 m-1">
                <button type="submit" class="btn m-2 icons-round icon-minus"  @click.stop.prevent="removeItem(i)">
                    <img src="~@/assets/icons/minus.svg">
                </button>
                <div v-for="(field, j) in item" :key="j">
                    <div v-if="j === 'background-image'" class="form-group">
                        <BackgroundImage :backgroundImage="itemArray[itemField][i][j]" :forTemplate="componentTemplate" />
                    </div>
                    <div v-if="j === 'src' && forTemplate === 'bio-bubble'" class="form-group">
                        <ImageUploader 
                            :key="i" :size="'bio'" 
                            :forTemplate="forTemplate" 
                            :imageFieldKey="j" 
                            :imageFieldObject="itemArray[itemField][i]" />
                    </div>
                    <div v-else-if="
                        (forTemplate === 'image-and-body-copy' && j === 'copy') || 
                        (forTemplate === 'bio-bubble' && j === 'description')"
                        class="form-group"
                        >
                            <label>{{ j }}</label>

                            <div id="app" class="ql-editor-container">
                                <vue-editor  v-model="itemArray[itemField][i][j]" :editorToolbar="customToolbar"></vue-editor>
                            </div>

                    </div>
                    <div v-else class="form-group">
                        <label>{{ j }}</label>
                        <input type="text" class="form-control" :id="j" v-model="itemArray[itemField][i][j]">
                    </div>
                </div>
            </div>
        </div>
        <div class="icon-add-container">
            <button type="submit" class="btn m-2 icons-round" @click.stop.prevent="addItem(template)">
                <img src="~@/assets/icons/add.svg">
            </button>
        </div>
  
    </div>
</template>

<script>
    import BackgroundImage from './BackgroundImage';
    import ImageUploader from './ImageUploader.vue';
    // import VueFroala from 'vue-froala-wysiwyg'
    // import 'froala-editor/css/froala_editor.pkgd.min.css';
    // import 'froala-editor/js/plugins/link.min.js';
    import { VueEditor } from "vue2-editor";
    import Vue from 'vue';
    Vue.use(VueEditor);

	export default {

        components: {
            BackgroundImage,
            VueEditor,
            ImageUploader
        },

		name: 'Repeater',
        
        props: ['itemArray', 'itemField', 'template', 'componentTemplate', 'forTemplate'],

        methods: {

            addItem(item) {
                this.itemArray[this.itemField].push(JSON.parse(JSON.stringify(item)));
            },

            removeItem(index) {
                this.itemArray[this.itemField] = this.itemArray[this.itemField].filter((el, i) => i !== index);
            }

        },
        data () {
            return {
                customToolbar: [["bold", "italic", ],["link"]]
            }
        }

    }
</script>

<style lang="scss">
    .ql-editor-container{
        .ql-editor{
            p:first-child{
                margin-top:0px;
            }
            p{
                margin-top:20px;
            }
        }
    }
</style>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
    }
    
    .icon-minus{
        float: right;
    }
    .icon-add-container{
        text-align: center;
    }
	
</style>